import { FC, useEffect } from "react";
import { FormField } from "../../../../ui-kit/FormField/FormField";
import { useHandleForm } from "../../../../hooks/useHandleForm";
import { Layout } from "../../../../ui-kit";
import styles from "./SessionSettings.module.scss";
import { IButton } from "../../../../ui-kit/IButton/IButton";
import { authStore } from "../../../../store/authStore";
import Paths from "../../../../constants/PathsBreadcrumbs";
import { useBreadcrumbs } from "../../../../hooks/useBreadcrumbs";
import { useStatusMessage } from "../../../../hooks/useStatusMessage";
import { observer } from "mobx-react-lite";

const SessionSettings: FC = observer(() => {
  const { errors, handleSubmit, register, reset, setValue, watchAllField } =
    useHandleForm(null, {
      sessionLifetime: null,
      sessionCount: null,
      inactivityDays: null,
    });

  const { getSessionConfig, loading, sessionConfig, setSessionConfig } =
    authStore;

  const onSubmit = (data) => {
    setSessionConfig(data);
  };

  useEffect(() => {
    getSessionConfig();
  }, []);

  useEffect(() => {
    if (sessionConfig) {
      reset(sessionConfig);
    }
  }, [sessionConfig]);

  useStatusMessage(authStore.messageStatus);
  useBreadcrumbs(Paths.adminSystemSession);

  return (
    <Layout type="white">
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <FormField
          register={register}
          name="sessionLifetime"
          type="number"
          label="Длина сессии для всех пользователей (минуты)"
          currentValue={watchAllField.sessionLifetime}
          registerOptions={{
            required: "Заполните поле",
          }}
          error={errors.sessionLifetime?.message}
        />
        <FormField
          register={register}
          name="sessionCount"
          type="number"
          label="Количество сессий"
          currentValue={watchAllField.sessionCount}
          registerOptions={{
            required: "Заполните поле",
          }}
          error={errors.sessionCount?.message}
        />
        <FormField
          register={register}
          name="inactivityDays"
          type="number"
          label="Время блокировки бездействующих пользователей (дни)"
          currentValue={watchAllField.inactivityDays}
          registerOptions={{
            required: "Заполните поле",
          }}
          error={errors.inactivityDays?.message}
        />
        <IButton loading={loading}>Сохранить</IButton>
      </form>
    </Layout>
  );
});

export default SessionSettings;
